import { createContext } from 'react';
import { IContext } from './index.d';

const TabbarContext = createContext<IContext>({
  keepMargin: true,
  setKeepMargin: () => undefined,
});

export default TabbarContext;